<template>
    <div>
      <b-table
          :items="documentsStateData"
          :fields="documentsColumns"
          :tbody-tr-class="rowClass"
          responsive
          sticky-header
          striped
          primary-key="id"
          show-empty
          editable
          empty-text="No hay registros"
          @row-clicked="editRow"
      >

      <template #cell(start_date)="{ item }">
                <div :style="{ backgroundColor: item.has_documents ? 'rgba(0, 167, 225, 0.2)' : '' }">
                    <template v-if="isRowEditable(item)">
                        <flat-pickr
                            v-model="item.start_date"
                            class="form-control width-115"
                            autocomplete="off"
                            name="effective_date"
                            :config="{ dateFormat: 'd-m-Y', locale: SpanishLocale, allowInput: true, altInput: true, altFormat: 'd-m-Y' }"
                        />
                    </template>
                    <template v-else>

              <span class="text-nowrap">
                {{ item.start_date }}
              </span>
                    </template>
                </div>
            </template>

            <template #cell(end_date)="{ item }">
                <div>
                    <template v-if="isRowEditable(item)">
                        <flat-pickr
                            v-model="item.end_date"
                            class="form-control width-115"
                            name="effective_date"
                            autocomplete="off"
                            :config="{ dateFormat: 'd-m-Y', locale: SpanishLocale, allowInput: true, altInput: true, altFormat: 'd-m-Y' }"
                        />
                    </template>
                    <template v-else>
              <span class="text-nowrap">
                 {{ item.end_date }}
              </span>
                    </template>
                </div>
            </template>

            <template #cell(provider_id)="{ item }">

                <template v-if="isRowEditable(item)">
                    <v-select
                        v-model="item.provider_id"
                        class="pt-0 width-300" label="provider" name="type"
                        :reduce="(option) => option.id"
                        :options="providers"
                        append-to-body
                        :calculate-position="withPopper"
                    />
                </template>
                <template v-else>
                    {{
                        providers.find(element => element.id == item.provider_id) ? providers.find(element => element.id == item.provider_id).provider : ''
                    }}
                </template>
            </template>


            <template #cell(order_number)="{ item }">
                <div :style="{ backgroundColor: item.has_documents ? 'rgba(0, 167, 225, 0.2)' : '' }">
                    <template v-if="isRowEditable(item)">
                        <b-form-input v-model="item.order_number" autocomplete="off"/>
                    </template>
                    <template v-else>
                        {{ item.order_number }}
                    </template>
                </div>
            </template>

            <template #cell(request_date)="{ item }">
                <div>
                    <template v-if="isRowEditable(item)">
                        <flat-pickr
                            v-model="item.request_date"
                            class="form-control width-115"
                            name="effective_date"
                            autocomplete="off"
                            :config="{ dateFormat: 'd-m-Y', locale: SpanishLocale, allowInput: true, altInput: true, altFormat: 'd-m-Y' }"
                        />
                    </template>
                    <template v-else>
                <span class="text-nowrap">
                 {{ item.request_date }}
                </span>
                    </template>
                </div>
            </template>

            <template #cell(order_maintenance_type_id)="{ item }">
                <template v-if="isRowEditable(item)">
                    <v-select
                        v-model="item.order_maintenance_type_id"
                        class="pt-0" label="type" name="type"
                        :reduce="(option) => option.id"
                        :options="orderMaintences"
                        append-to-body
                        :calculate-position="withPopper"
                    />
                </template>
                <template v-else>
                    {{
                        orderMaintences.find(element => element.id == item.order_maintenance_type_id) ? orderMaintences.find(element => element.id == item.order_maintenance_type_id).type : ''
                    }}
                </template>
            </template>

            <template #cell(order_maintenance_sub_type_id)="{ item }">
                <template v-if="isRowEditable(item)">
                    <v-select
                        v-model="item.order_maintenance_sub_type_id"
                        class="pt-0 width-300" label="type" name="type"
                        :reduce="(option) => option.id"
                        :options="orderSubMaintences"
                        append-to-body
                        :calculate-position="withPopper"
                    />
                </template>
                <template v-else>
                    {{
                        orderSubMaintences.find(element => element.id == item.order_maintenance_sub_type_id) ? orderSubMaintences.find(element => element.id == item.order_maintenance_sub_type_id).type : ''
                    }}
                </template>
            </template>

            <template #cell(amount)="{ item }">
                <template v-if="isRowEditable(item)">
                    <b-form-input v-model="item.amount" class="form-control width-200" autocomplete="off"/>
                </template>
                <template v-else>
                    €{{ item.amount }}
                </template>
            </template>

            <template #cell(observations)="{ item }">
                <template v-if="isRowEditable(item)">
                    <b-form-input v-model="item.observations" autocomplete="off"/>
                </template>
                <template v-else>
                    {{ item.observations }}
                </template>
            </template>

            <template #cell(options)="data">
                <div class="d-flex align-items-center">
                    <feather-icon
                        v-if="deletePermission && !showLoading"
                        :id="`record-row-${data.item.id}-edit-icon`"
                        :icon="getButtonIcon(data.item)"
                        class="cursor-pointer mr-1"
                        :class="getButtonVariant(data.item)"
                        size="16"
                        @click="handleEditButtonClick($event, data.item)"
                    />

                    <feather-icon
                        v-if="data.item.id && !showLoading"
                        :id="`record-row-${data.item.id}-see-icon`"
                        icon="SearchIcon"
                        size="16"
                        variant="warning"
                        class="cursor-pointer mr-1 text-blue"
                        @click="seeDocumentsList(data.item.id,true)"
                    />
                    <feather-icon
                        v-if="deletePermission && !showLoading"
                        :id="`record-row-${data.item.id}-delete-icon`"
                        icon="TrashIcon"
                        size="16"
                        class="cursor-pointer mr-1 text-red"
                        @click="deleteRecord(data.item.id, data.index )"
                    />
                    <feather-icon
                        v-if="deletePermission && !showLoading"
                        :id="`record-row-${data.item.id}-see-log-icon`"
                        icon="ClockIcon"
                        size="16"
                        class="cursor-pointer text-success"
                        @click="seeLogsDocument(data.item.id, data.item.logs)"
                    />
                    <b-spinner
                        v-if="showLoading"
                        small
                        variant="secondary"
                    ></b-spinner>
                </div>
            </template>

        </b-table>

        <b-modal v-model="showModal" hide-footer title="Documentos" size="lg" @hidden="closeModal">
            <b-table
                ref="refUserListTable"
                :items="documentsRoute"
                responsive
                :fields="columnsDocuments"
                primary-key="id"
                show-empty
                sticky-header
                striped
                editable
                empty-text="No hay registros"
                class="table-bordered "
                :key-field="'index'"
            >
                <template #cell(options)="data">
                    <div class="d-flex align-items-center justify-content-center">
                        <a :href="baseUrl+data.item.path" target="_blank">
                            <feather-icon
                                v-if="!can('gei_delete_document_contract_client_ee')"
                                :id="`record-row-${data.item.id}-see-icon`"
                                icon="EyeIcon"
                                size="16"
                                variant="warning"
                                class="cursor-pointer mr-1 text-blue"
                                @click="seeDocument(currentDocumentId, data.item.path)"
                            />
                        </a>
                        <feather-icon
                            v-if="deletePermission"
                            :id="`record-row-${data.item.id}-delete-icon`"
                            icon="TrashIcon"
                            size="16"
                            class="cursor-pointer text-red"
                            @click="deleteDocument(currentDocumentId, data.item.path, data.item.name)"
                        />
                    </div>
                </template>
            </b-table>
            <template>
                <div v-if="currentDocumentId>0">
                    <b-overlay
                        variant="white"
                        :show="showLoading"
                        spinner-variant="primary"
                        blur="0"
                        opacity=".75"
                        rounded="sm"
                    >
                        <vue-dropzone
                            v-if="deletePermission"
                            id="dropzone"
                            ref="dropzone"
                            :options="dropzoneOptions"
                            :use-custom-slot="true"
                            @vdropzone-complete="complete">
                            <div class="dropzone-custom-content">
                                <h3 class="dropzone-custom-title">Arrastrar y soltar para subir archivo</h3>
                                <div class="subtitle">...o hacer clic para seleccionar un archivo de tu ordenador
                                </div>
                            </div>
                        </vue-dropzone>
                    </b-overlay>
                </div>
            </template>

            <b-button class="mt-3" variant="outline-danger" block @click="closeModal()">Cerrar</b-button>
        </b-modal>

      <log-modal
          v-model="showLogsModal"
          :show-logs-modal="showLogsModal"
          :logs="logsData"
          :per-page="logsPerPage"
      />
    </div>
</template>

<script>
import {BTable, BFormInput, BModal, BButton, BOverlay, BFormGroup, BSpinner} from 'bootstrap-vue'
import {baseUrl} from "@/constants/app"
import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es'
import authService from "@/services/auth/authService"
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import flatPickr from "vue-flatpickr-component"
import VueDropzone from "vue2-dropzone"
import helper from "@/resources/helpers/helpers"
import Swal from "sweetalert2"
import vSelect from "vue-select"
import {mapState} from "vuex"
import {mapFields} from "vuex-map-fields"
import {createPopper} from '@popperjs/core'
import logModal from "@/views/gei/documents_log/logModal.vue"
export default {
    components: {
        BSpinner,
        logModal,
        BTable,
        BFormInput,
        BModal,
        BButton,
        BOverlay,
        flatPickr,
        vSelect,
        VueDropzone: VueDropzone,
    },
    props: {
        documentsStateData: {
            type: Array,
            required: true
        },
        documentsColumns: {
            type: Array,
            required: true
        },
        documentsRoute: {
            type: Array,
            required: true
        },
        context: {
            type: String,
            required: true
        },
        createPermission: {
            type: Boolean,
        },
        deletePermission: {
            type: Boolean,
        }
    },

    data() {
        return {
            baseUrl,
            currentDocumentId: null,
            selectedRow: null,
            placement: 'top',

            showLogsModal: false,
            logsData: [],
            logsPerPage: 5,
            currentPage: 1,

            showModal: false,
            SpanishLocale,
            edit: false,
            showLoading: false,
            urlDocs: null,
            editedRow: null,
            columnsDocuments: [
                {key: 'options', label: 'Acciones', sortable: false},
                {key: 'name', label: 'Archivo', sortable: false},
            ],
            dropzoneOptions: {},
        }
    },
    computed: {
        ...mapState('providers', []),
        ...mapState('orderMaintences', []),
        ...mapState('orderSubMaintences', []),
        ...mapState('documentsTypes', []),
        ...mapFields({
            providers: 'providers.providers',
            orderMaintences: 'orderMaintences.orderMaintences',
            orderSubMaintences: 'orderSubMaintences.orderSubMaintences',

            documentsTypes: 'documentsTypes.document_types',
            industryOwnerships: 'industryOwnerships.industry_ownerships',

        }),
        totalPages() {
          return Math.ceil(this.logsData.length / this.logsPerPage)
        },
        paginatedLogs() {
          const start = (this.currentPage - 1) * this.logsPerPage
          const end = start + this.logsPerPage
          return this.logsData.slice(start, end)
        },
    },
    mounted() {
        this.getAllIndustryOwnerships()

    },
    methods: {
        can(permission) {
            return this.$store.getters.can(permission)
        },
        withPopper(dropdownList, component, {width}) {
            dropdownList.style.width = width
            const popper = createPopper(component.$refs.toggle, dropdownList, {
                placement: this.placement,
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -1],
                        },
                    },
                    {
                        name: 'toggleClass',
                        enabled: true,
                        phase: 'write',
                        fn({state}) {
                            component.$el.classList.toggle(
                                'drop-up',
                                state.placement === 'top'
                            )
                        },
                    },
                ],
            })


            return () => popper.destroy()
        },
        isRowEditable(item) {
          if (!this.deletePermission) {
            return false
          }
          return item === this.editedRow || item === this.documentsStateData.editedRow
        },
        handleEditButtonClick(event, item) {
          event.stopPropagation()
          this.editRow(item)
        },
        editRow(item) {
            if (this.isRowEditable(item)) {
                this.editedRow = null
                this.updateRecord(item)

            } else {
                this.editedRow = item
            }
        },
        getButtonVariant(item) {
            return this.isRowEditable(item) ? 'text-green' : 'info'
        },
        getButtonIcon(item) {
            return this.isRowEditable(item) ? 'CheckIcon' : 'EditIcon'
        },
        getButtonText(item) {
            return this.isRowEditable(item) ? 'Guardar' : 'Editar'
        },
        closeModal() {
            this.showModal = false
            this.$root.$refs.childrenInstallationForm.getChildInstallation()
        },
        seeDocumentsList(id, logBool) {
            this.showLogsModal = false
            this.currentDocumentId = id
            this.updateDropzoneOptions()
            if (logBool) {
              this.setDocumentActionLog(id, 'seeList', 'Ha visto el listado de documentos')
            }
            this.$store.dispatch('childrenInstallationDocuments/getDocumentsList', {id: id, context: this.context})
            .then(response => {
                this.showLoading = false
                this.showModal = true
            })
            .catch(error => {
                this.showLoading = false
            })
        },
        updateDropzoneOptions() {
            this.dropzoneOptions = {
                url: baseUrl + 'api/gei/children-installation/documents/' + this.context + '/upload-documents/' + this.currentDocumentId,
                thumbnailWidth: 150,
                thumbnailHeight: 150,
                autoProcessQueue: true,
                addRemoveLinks: true,
                headers: {"Authorization": 'Bearer ' + authService.accessToken()},
            }
        },
        complete: function (file) {
            this.showLoading = true
            this.seeDocumentsList(this.currentDocumentId,false)
            let infoLog = 'Ha subido el documento ' + file.name
            this.setDocumentActionLog(this.currentDocumentId, 'upload', infoLog)
            setTimeout(() => {
                this.$refs.dropzone.removeAllFiles()
            }, 2000)
        },
        updateRecord(item) {

            item.context = this.context

            if (item.id) {
                this.$store.dispatch('childrenInstallationDocuments/updateRecordGeneralData', item)
                .then(() => {
                    this.showLoading = false
                    this.$root.$refs.childrenInstallationForm.getChildInstallation()
                    helper.resetVariable(this.record)
                    helper.showToast('Registro actualizado correctamente!', 'CheckIcon', 'success')
                })
                .catch(error => {
                    this.showLoading = false
                    helper.showToast('Error en editar al actualizar registro', 'AlertOctagonIcon', 'danger')
                })
            } else {
                this.$store.dispatch('childrenInstallationDocuments/createRecordGeneralData', item)
                .then(() => {
                    this.showLoading = false
                    this.$root.$refs.childrenInstallationForm.getChildInstallation()
                    helper.resetVariable(this.record)
                    helper.showToast('Registro creado correctamente!', 'CheckIcon', 'success')
                })
                .catch(error => {
                    this.showLoading = false
                    helper.showToast('Error en editar al crear registro', 'AlertOctagonIcon', 'danger')
                })
            }
        },
        deleteRecord(id, index) {
            if (id) {
                Swal.fire({
                    title: "Estás seguro que quieres borrar el registro?",
                    text: "Una vez borrado no se podrá recuperar!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "¡Sí, borralo!",
                    cancelButtonText: "Cancelar",
                }).then(result => {
                    if (result.value) {
                        this.showLoading = true
                        this.$store.dispatch('childrenInstallationDocuments/deleteRecord', {
                            id: id,
                            context: this.context
                        })
                        .then(response => {
                            this.showLoading = false
                            helper.showToast('Registro eliminado correctamente!', 'CheckIcon', 'success')
                            this.$root.$refs.childrenInstallationForm.getChildInstallation()
                        })
                        .catch(error => {
                            this.showLoading = false
                            console.log(error)
                        })
                    }
                })
            } else {
                this.documentsStateData.splice(index, 1)
            }
        },
        getAllIndustryOwnerships() {
            this.showLoading = true

            this.$store.dispatch('industryOwnerships/getAllIndustryOwnerships')
            .then(response => {
                this.showLoading = false
            })
            .catch(error => {
                this.showLoading = false
            })
        },
        deleteDocument(recordId, path, name) {
            if (recordId) {
                const fileName = path.split('/').pop()
                const pathParts = path.split('/')
                const folderNumber = pathParts[pathParts.length - 2]

                Swal.fire({
                    title: "Estás seguro que quieres borrar el archivo?",
                    text: "Una vez borrado no se podrá recuperar!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "¡Sí, borralo!",
                    cancelButtonText: "Cancelar",
                }).then(result => {
                    if (result.value) {
                        this.showLoading = true
                        this.$store.dispatch('childrenInstallationDocuments/deleteAllDocuments', {
                          id:  this.currentDocumentId,
                          path: path,
                          name: name,
                          context: this.context
                        })
                        .then(response => {
                            this.showLoading = false
                            let infoLog = 'Ha eliminado el documento ' + fileName
                            this.setDocumentActionLog(recordId, 'delete', infoLog)
                            this.$root.$refs.childrenInstallationForm.getChildInstallation()
                            helper.showToast('Registro eliminado correctamente!', 'CheckIcon', 'success')
                            this.seeDocumentsList(this.currentDocumentId,false)
                        })
                        .catch(error => {
                            this.showLoading = false
                            console.log(error)
                        })
                    }
                })
            }
        },
        rowClass(item, type) {
            if (!item || type !== 'row') return
            if (item.master || item.document_id) return 'row_shared'
        },
        setDocumentActionLog(id, action, info) {
          this.$store.dispatch('logDocuments/setDocumentActionLog', {
            id: id,
            model: this.context,
            action: action,
            info: info,
          })
        },
        seeDocument(recordId, path) {
          if (recordId) {
            const fileName = path.split('/').pop()
            const pathParts = path.split('/')
            const folderNumber = pathParts[pathParts.length - 2]

            let infoLog = 'Ha visto el documento ' + fileName
            this.setDocumentActionLog(recordId, 'see', infoLog)
          }
        },
        seeLogsDocument(id, logs) {
          this.showLogsModal = false
          this.logsData = logs.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
          this.$nextTick(() => {
            this.showLogsModal = true
          })
        },
        closeLogsModal() {
          this.logsData = []
          this.currentPage = 1
          this.showLogsModal = false
          this.$emit("update:showLogsModal", false)
        },
        formatDateTime(datetime) {
          const date = new Date(datetime)
          const formattedDate = date.toLocaleDateString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          })
          const formattedTime = date.toLocaleTimeString('es-ES', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
          })
          return `${formattedDate} ${formattedTime}`
        },
        previousPage() {
          if (this.currentPage > 1) {
            this.currentPage--
          }
        },
        nextPage() {
          if (this.currentPage < this.totalPages) {
            this.currentPage++
          }
        },
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

[dir] .modal .modal-header .close {
    box-shadow: none;
    transform: unset;
    background: none;
}

.v-select.drop-up.vs--open .vs__dropdown-toggle {
    border-radius: 0 0 4px 4px;
    border-top-color: transparent;
    border-bottom-color: rgba(60, 60, 60, 0.26);
}

[data-popper-placement='top'] {
    border-radius: 4px 4px 0 0;
    border-top-style: solid;
    border-bottom-style: none;
    box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}

.row_shared{
    background-color: #cbe7ff !important;
}
</style>